export const shouldOverrideLockSelector = state => state.featureFlags.overrideLock || false;
